<template>
  <div class="form-debug">
    <FormRender
      v-if="showRender"
      :value="formModel"
      :formCode="codeData"
      :formJSON="formJSON"
      :formRules="formRules"
      :usedMap="usedMap"
      :publicSource="publicSource"
      :process="process"
      :readonly="readonly"
      :done="done"
    />
  </div>
</template>

<script>
import { replacePublic } from '@workflow/mixins/index.js'
import FormRender from './formRender.vue'
export default {
  components: {
    FormRender
  },
  mixins: [replacePublic],
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  provide() {
    return {
      parentVueData: this.parentVueData
    }
  },
  data() {
    return {
      showRender: false,
      process: this.$route.query.process || 'start',
      readonly: this.$route.query.readonly === 'true',
      done: this.$route.query.done === 'true',
      formModel: {},
      codeData: {},
      formJSON: {},
      formRules: {},
      parentVueData: {}
    }
  },
  watch: {
    '$route'(val) {
      window.location.reload()
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      let data = this.data || ((window.opener && !window.opener.closed) ? window.opener.localData : null)
      if (!data) {
        data = JSON.parse(localStorage.debugData || '[]').find(item => item.id === this.$route.query.id) || {}
      }
      this.codeData = data.codeData || {}
      this.formJSON = data.formJSON || {}
      Promise.all([this.initModel(), this.initRule(), this.initPublic(), this.initLinks()]).then(() => {
        this.showRender = true
      })
    },
    initModel() {
      return new Promise(resolve => {
        if (this.$route.query.processInstanceId) {
          this.$api.formModel.getForm({
            processInstanceId: this.$route.query.processInstanceId
          }).then(data => {
            try {
              this.formModel = data.editorJson.model || {}
              this.parentVueData.processInstanceData = data
            } catch (error) {
              console.log(error)
            }
            resolve()
          })
        } else {
          resolve()
        }
      })
    },
    initRule() {
      return new Promise(resolve => {
        if (!this.$route.query.modelKey) {
          resolve()
          return
        }
        this.$api.formModel.getFormRule({
          type: '3', // 表单权限
          modelKey: this.$route.query.modelKey,
          nodeId: this.$route.query.nodeId || 'start_fixed_node'
        }).then(data => {
          if (data && data.value) {
            this.formRules = JSON.parse(data.value)
          }
          resolve()
        })
      })
    },
    initPublic() {
      return new Promise(resolve => {
        Promise.all([this.$api.formAssembly.selectAll(), this.$api.public.selectAll()]).then(data => {
          this.initReplace(...data)
          window.$componentsList = this.publicComponentList
          window.$components = this.publicComponentMap
          window.$usedMap = this.usedMap
          resolve()
        })
      })
    },
    initLinks() {
      return new Promise(resolve => {
        this.links = [Promise.resolve()]
        const _el = document.createElement('div')
        _el.innerHTML = this.codeData.links
        const el = document.createElement('div')
        if (_el.childNodes) {
          _el.childNodes.forEach(item => this.eachLink(item, el))
        }
        document.body.appendChild(el)
        window.$links = el
        Promise.all(this.links).then(() => {
          resolve()
        })
      })
    },
    eachLink(node, el) {
      if (!node.tagName) return
      const tagName = node.tagName.toLocaleLowerCase()
      const child = document.createElement(tagName)
      if (tagName === 'script') {
        child.setAttribute('src', node.src)
      } else if (tagName === 'link') {
        child.setAttribute('rel', node.rel)
        child.setAttribute('charset', node.charset)
        child.setAttribute('type', node.type)
        child.setAttribute('href', node.href)
      }
      tagName === 'script' && this.links.push(new Promise(resolve => {
        child.onload = function() {
          resolve()
        }
      }))
      el.appendChild(child)
      if (node.childNodes) {
        node.childNodes.forEach(item => this.eachLink(item, child))
      }
    }
  }
}
</script>
<style lang="scss">
.form-debug {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  padding: 10px;
  overflow: auto;
}
</style>
